import React from 'react';
import avatarMan from '../../../../../assets/images/avatars/avatar-man.svg';
import avatarWoman from '../../../../../assets/images/avatars/avatar-woman.svg';
import { resolveProfilePictureSrc } from '../../../application/mapUserProfile';

export type PictureByGenderProps = {
  picture?: string | null;
  gender?: string | null;
  className?: string;
  clazz?: string;
};

export const PictureByGender: React.FC<PictureByGenderProps> = ({
  picture,
  gender,
  className,
  clazz,
}) => {
  const src = resolveProfilePictureSrc(picture, gender, {
    man: avatarMan,
    woman: avatarWoman,
  });

  return <img src={src} className={className || clazz || ''} alt="" />;
};

export default PictureByGender;
